import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { checkToken, logoutSuccess } from 'redux/modules/auth';
import { setAccessToken } from 'supports/api';
import { Route, Switch } from 'react-router-dom';

import SignIn from 'pages/sign-in';
import Header from 'components/Header';
import AdminPage from './components/AdminPage';
import './supports/css/bootstrap.css';
import './supports/css/app.css';
import './supports/css/animate.css';
import './FAIcons';
import Sandbox from './Sandbox';

export default () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(checkToken());
  }, [dispatch]);

  // Cross-tab logout: listen for logout events from other tabs
  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === 'logout_event') {
        setAccessToken(null);
        dispatch(logoutSuccess());
      }
    };
    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, [dispatch]);

  return (
    <div>
      <Header />
      <div
        className="body-app"
        style={{ minHeight: '100vh', backgroundColor: '#e8e8e8' }}
      >
        <Switch>
          <Route exact path="/" component={SignIn} />
          <Route exact path="/admin/sandbox" component={Sandbox} />
          <Route path="/admin" component={AdminPage} />
        </Switch>
      </div>
    </div>
  );
};
